import styled from '@emotion/styled'

/**
 * FilterChips — pill 모양 단일 선택 필터.
 * `<button aria-pressed>` 패턴 + attribute selector로 분기 (Tabs와 동일 원칙).
 */

export const ChipsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`

export const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 7px 17px;
  border: 1px solid #e4e5e7;
  border-radius: 18px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #3f4145;
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  &[aria-pressed='true'] {
    background: #1b1c1d;
    border-color: #1b1c1d;
    color: #ffffff;
  }

  &:active {
    opacity: 0.7;
  }
`
